// Shared tri-state semantics for the collapsible enable flags
// (entryConditionEnabled / exitConditionEnabled):
//   'true'  → on
//   'false' → off
//   '' / undefined → unset, falls back to "on when data is present" so configs
//      saved before the flag existed (and the auto-on-when-edited model) keep working.
// Single source of truth for isTriggerActive / isExitActive.
export function resolveEnableFlag(flag: string | undefined, hasData: boolean): boolean {
  if (flag === 'true') return true
  if (flag === 'false') return false
  return hasData
}

/** True when the user has not made an explicit on/off choice yet (auto-arm window). */
export function isEnableFlagUnset(flag: string | undefined): boolean {
  return flag !== 'true' && flag !== 'false'
}
